import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, HostBinding, Input, ViewChild, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from 'se-fe-form-service';
import { SeFeFormControlDirective, SE_FE_FORM_FIELD_INPUT } from 'se-fe-form-service';

class SeFeFormFieldTextStylesComponent {
}
SeFeFormFieldTextStylesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextStylesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeFormFieldTextStylesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeFormFieldTextStylesComponent, selector: "[seFeFormFieldTextStyles]", ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".se-fe-form-field-text__label>*:not(.se-fe-form-field-text__input):not(se-fe-chip):not(se-fe-removable-chip):not(se-fe-icon){margin-left:6px!important;margin-right:6px!important}.se-fe-form-field-text__label>se-fe-chip,.se-fe-form-field-text__label>se-fe-removable-chip{margin:2px!important}.se-fe-form-field-text__label>se-fe-icon{margin:0 6px!important}.se-fe-form-field-text__label>se-fe-icon:first-child{margin-right:0!important}.se-fe-form-field-text__label>se-fe-icon:last-child{margin-left:0!important}.se-fe-form-field-text>*{flex:0 0 auto}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextStylesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[seFeFormFieldTextStyles]',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-form-field-text-styles.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class SeFeFormFieldTextComponent extends SeFeFormControlDirective {
    constructor(injector, seFeFormService) {
        super(injector, seFeFormService);
        this.injector = injector;
        this.seFeFormService = seFeFormService;
        this.labelFor = `se-fe-label-${SeFeFormFieldTextComponent.timeStamp}-${SeFeFormFieldTextComponent.labelCounter++}`;
        this.baseClass = true;
        this.hasFocus = false;
        this.seFeDataWrap = false;
        this.seFeDataComfy = false; // TODO: remove this and make it default in 2.0 release
        this.seFeDataType = 'text';
        this.seFeDataReadOnly = false;
    }
    get errorClass() { return !!this.errors.length; }
    get legacyClass() { return !this.seFeDataComfy; }
    get disabledClass() { var _a; return !!((_a = this.control) === null || _a === void 0 ? void 0 : _a.disabled); }
    ngAfterViewInit() {
        this.updateInputSize();
        this.listenForDisable();
    }
    inputChange($event) {
        super.inputChange($event);
        this.updateInputSize();
    }
    textInputFocus() {
        var _a, _b;
        (_b = (_a = this.input) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.focus();
    }
    toggleFocus(evt) {
        if (evt.type === 'focus')
            this.hasFocus = true;
        if (evt.type === 'blur') {
            this.touched(evt);
            this.hasFocus = false;
        }
    }
    get isReadOnly() {
        return this.seFeDataReadOnly ? true : undefined;
    }
    listenForDisable() {
        this.setDisabledStatus(this.control.status);
        this.control.statusChanges.subscribe(status => this.setDisabledStatus(status));
    }
    setDisabledStatus(status) {
        var _a;
        const elem = (_a = this.input) === null || _a === void 0 ? void 0 : _a.nativeElement;
        if (!elem)
            return;
        elem.disabled = status === 'DISABLED';
    }
    updateInputSize() {
        const el = this.input.nativeElement;
        el.style.width = '';
        const boxWidth = el.offsetWidth + 1; // account for rounding errors
        const textWidth = el.scrollWidth;
        if (textWidth > boxWidth)
            el.style.width = `${textWidth}px`;
    }
}
SeFeFormFieldTextComponent.timeStamp = Date.now();
SeFeFormFieldTextComponent.labelCounter = 1;
SeFeFormFieldTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextComponent, deps: [{ token: i0.Injector }, { token: i1.SeFeFormService }], target: i0.ɵɵFactoryTarget.Component });
SeFeFormFieldTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeFormFieldTextComponent, selector: "se-fe-form-field-text", inputs: { seFeDataWrap: "seFeDataWrap", seFeDataComfy: "seFeDataComfy", seFeDataType: "seFeDataType", seFeDataReadOnly: "seFeDataReadOnly", seFeDataAutoComplete: "seFeDataAutoComplete", seFeDataInputMode: "seFeDataInputMode", seFeDataPlaceholder: "seFeDataPlaceholder" }, host: { properties: { "class.se-fe-form-field-text": "this.baseClass", "class.se-fe-form-field-text--errors": "this.errorClass", "class.se-fe-form-field-text--legacy": "this.legacyClass", "class.se-fe-form-field-text--disabled": "this.disabledClass", "class.se-fe-form-field-text--focused": "this.hasFocus", "class.se-fe-form-field-text--wrap": "this.seFeDataWrap" } }, providers: [
        {
            provide: SE_FE_FORM_FIELD_INPUT,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            useExisting: SeFeFormFieldTextComponent,
        },
    ], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div (click)=\"textInputFocus()\" seFeFormFieldTextStyles class=\"se-fe-form-field-text__label\">\n  <ng-content select=\"[seFeFormFieldTextBefore]\"></ng-content>\n  <input\n    #input\n    id=\"{{ labelFor }}\"\n    type=\"{{ seFeDataType }}\"\n    (input)=\"inputChange($event)\"\n    (blur)=\"toggleFocus($event)\"\n    (focus)=\"toggleFocus($event)\"\n    placeholder=\"{{ seFeDataPlaceholder }}\"\n    value=\"{{ control.value }}\"\n    [attr.aria-describedby]=\"helpErrorIds\"\n    class=\"se-fe-form-field-text__input\"\n    [attr.inputmode]=\"seFeDataInputMode\"\n    [attr.autocomplete]=\"seFeDataAutoComplete\"\n    [attr.readonly]=\"isReadOnly\"\n  />\n  <ng-content select=\"[seFeFormFieldTextAfter]\"></ng-content>\n</div>\n<ng-content select=\"[seFeFormFieldTextAction]\"></ng-content>\n", styles: [":host{border-color:#c1cace}:host.se-fe-form-field-text--disabled input:disabled{background-color:#fff;color:#c1cace}:host.se-fe-form-field-text--errors{border-color:#b42846}:host{background:#fff;border-radius:4px;border-style:solid;border-width:1px;box-sizing:border-box;color:#23282b;font:normal 400 calc(var(--se-rem, 1rem) * 1)/1.4286 \"Open Sans\",sans-serif;font-size:calc(var(--se-rem, 1rem) * 1);line-height:18px;width:100%}:host .se-fe-form-field-text__input{border:0;padding:0;margin:0;font:inherit}:host .se-fe-form-field-text__input:focus{outline:none}:host{display:flex;flex-wrap:wrap;font:normal 400 calc(var(--se-rem, 1rem) * 1)/1.4286 \"Open Sans\",sans-serif}:host.se-fe-form-field-text--focused{box-shadow:0 0 0 calc(0px + 2px) #fff,0 0 0 calc(0px + 4px) #00668f,0 0 0 calc(0px + 6px) #fff}:host .se-fe-form-field-text__label{align-items:center;color:#68767f;cursor:text;display:flex;flex:1 1 0;flex-wrap:nowrap;padding:6px;overflow:hidden}:host .se-fe-form-field-text__input{color:#23282b;flex:1 1 auto;line-height:18px;padding:8px 6px!important;width:0;text-overflow:ellipsis}:host .se-fe-form-field-text__input::placeholder{color:#c1cace}:host.se-fe-form-field-text--legacy .se-fe-form-field-text__label{padding-bottom:0;padding-top:0}:host.se-fe-form-field-text--wrap .se-fe-form-field-text__label{flex-wrap:wrap}\n"], components: [{ type: SeFeFormFieldTextStylesComponent, selector: "[seFeFormFieldTextStyles]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-form-field-text',
                    templateUrl: './se-fe-form-field-text.component.html',
                    styleUrls: ['./se-fe-form-field-text.component.scss'],
                    providers: [
                        {
                            provide: SE_FE_FORM_FIELD_INPUT,
                            // eslint-disable-next-line @typescript-eslint/no-use-before-define
                            useExisting: SeFeFormFieldTextComponent,
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i1.SeFeFormService }]; }, propDecorators: { baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text']
            }], errorClass: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--errors']
            }], legacyClass: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--legacy']
            }], disabledClass: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--disabled']
            }], hasFocus: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--focused']
            }], seFeDataWrap: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--wrap']
            }, {
                type: Input
            }], seFeDataComfy: [{
                type: Input
            }], seFeDataType: [{
                type: Input
            }], seFeDataReadOnly: [{
                type: Input
            }], seFeDataAutoComplete: [{
                type: Input
            }], seFeDataInputMode: [{
                type: Input
            }], seFeDataPlaceholder: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['input']
            }] } });

class SeFeFormFieldTextModule {
}
SeFeFormFieldTextModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeFormFieldTextModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextModule, declarations: [SeFeFormFieldTextComponent,
        SeFeFormFieldTextStylesComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule], exports: [SeFeFormFieldTextComponent,
        FormsModule,
        ReactiveFormsModule] });
SeFeFormFieldTextModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextModule, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
        ], FormsModule,
        ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SeFeFormFieldTextComponent,
                        SeFeFormFieldTextStylesComponent,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    exports: [
                        SeFeFormFieldTextComponent,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeFormFieldTextComponent, SeFeFormFieldTextModule };
